import React from 'react';

import { useLocation, useParams, Outlet } from 'react-router-dom';

import TablePageLayout from '../TablePageLayout';

import TetriaryNav from '../../components/TetriaryNav';

export default function EditBrokerTeamLayout() {
  const { id } = useParams();
  const location = useLocation();
  const createPage = location.pathname === '/settings/teams/create';
  const usersPage = location.pathname.includes('users');

  const navLinks = [
    {
      title: 'Team',
      url: `/settings/teams/${id}`,
    },
    {
      title: 'Users',
      url: `/settings/teams/${id}/users`,
    },
  ];

  let title = '';

  if (usersPage) {
    title = 'Team Users';
  } else {
    title = createPage ? 'Create Team' : 'Edit Team';
  }

  return (
    <div className={`bg-white h-full ${createPage ? 'pt-10' : ''}`}>
      {!createPage && (
        <div className="bg-white pt-5 px-7 md:px-10 mb-4">
          <TetriaryNav navLinks={navLinks} />
        </div>
      )}
      <TablePageLayout
        title={title}
        className="bg-white dark:bg-gray-800"
        contentClassName={usersPage ? '' : '!max-w-[672px]'}
      >
        <Outlet />
      </TablePageLayout>
    </div>
  );
}
